export default __webpack_public_path__ + "static/media/bentobox-hero.24395156.jpg";